import React from 'react'
import MyClassesList from '~components/MyClassesList'

export default function MyClassesScreen(): React.JSX.Element {
  return <MyClassesList create="none" />
}
